<template>
  <v-card-title class="pb-4 d-flex justify-space-between">
    <span>
      {{ title }}
    </span>

    <v-btn
      class="pr-0"
      min-width="20"
      color="lightGrey"
      plain
      small
      :ripple="false"
      @click="close"
    >
      <v-icon class="uikit-icon close size-20" />
    </v-btn>
  </v-card-title>
</template>

<script>
export default {
  name: 'DialogCardTitle',

  props: {
    title: String
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped></style>
